module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP1",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cotx"
  }, [_vm._v("“SHE SOUNDS LIKE")]), _vm._v(" some piece of work, this Ruby.” Morrow holstered his notebook inside his jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She wasn’t all bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Coming between a girl and her mother’s memory? Did other girls in the house have items go missing?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The ones who’d roomed with Ruby before me had the same problem.” I frowned. “A little advance notice would have been appreciated.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re a stout judge of character if you didn’t care for Tommy Carpa.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow nodded. “Guy’s an operator.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hansen clucked from the other side of the room, evidently favoring stronger language.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“First time we’ve heard his name in connection to Miss Carroll,” Morrow said. “No one at the boardinghouse mentioned him.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He may be out of the picture by now. I didn’t keep up with Ruby’s social calendar.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Right. Six months since you last saw her.” Morrow eyed Hansen. “Figure a call on Tommy is in order?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Tonight,” Hansen said. “When his club’s open and his high-hat pals are in attendance.” He chuckled, the sound like a match strike near dry brush.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The newspaper said Ruby was wearing an evening gown and a lot of jewelry.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They laid it on a bit thick to play up the Alley Angel angle,” Morrow said. “The jewelry was paste, costume stuff. Now the dress was something. Looked pricey to me, but what do I know? You work in a department store. Maybe you’d have an idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I can tell you Ruby never had her share of the rent on time. The gown could have been a gift from an admirer. She did tend to collect men friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe the Shark bought the duds for her,” Hansen said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I turned to him. “The Shark?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Carpa. Fair-sized fish fancies himself a bigger one. Still a minnow swimming in Mickey Cohen’s wake, but growing bigger all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The gambit was a long shot, but I played it anyway. “Perhaps if I saw the gown, I could tell you something about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’d be willing to do that?” Morrow asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“If there’s any chance I could give you an idea of when and where Ruby got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow nodded thoughtfully. “Sure. And while you’re at it, you could take a gander at Ruby’s jewelry. Look for that pilfered brooch of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I felt my skin flush. “You saw right through me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, Miss Frost. Truth be told, it wasn’t that mighty a challenge.” Now, though, he seemed to be weighing the idea’s merits. “It couldn’t hurt to have you look at the dress. And at the station I could scrounge up enough chairs for everybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We made quite the procession heading toward the escalators, the curious faces of the other salesgirls staring after us. My notoriety had spread across the second floor, and I was the center of attention. For an instant, I felt like Ruby.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_c('span', {
    staticClass: "sbtx"
  }, [_vm._v("THE POLICE STATION")]), _vm._v(" did not live up to my expectations. No gaggle of wisecracking reporters, nary an immigrant mother begging to visit her son before he went up the river. The movies had deceived me again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hansen lingered in the parking lot to crack knuckles with another detective. Morrow escorted me inside, shouldering a door marked R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OBBERY")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OMICIDE")]), _vm._v(" D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IVISION")]), _vm._v(". The masculine aroma beyond, a potent combination of sweat, smoke, and hair tonic, nearly KO’d me. Shirtsleeved men raised their heads as we walked by. Behind me I heard, “Nice going, Gene. Got one for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow sat me down next to a desk that, compared to the others we’d passed, was immaculate. He placed a folder in front of me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s this?” I already knew the answer. Photographs of Ruby in the alley behind Keshek’s Meat Market, lifeless in black and white.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You said you could identify Ruby’s clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, but I thought you’d show me the clothes themselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Either you recognize them or you don’t,” Hansen said, the bad penny turning up again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“With a picture there’s no way to see the fabric’s color, examine the … the warp and weft.” That sounded almost believable, even to me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow gave me a skeptical look and then walked Hansen over to a bank of file cabinets, out of earshot. I occupied myself with an inventory of his desk. One smudged ashtray, empty if not clean. A second ashtray containing a battered baseball, the sole indication of a life beyond this office. No photographs of a new bride posing by the sleeping car in her going-away suit, or a fresh-faced kid with a soapbox derby trophy. And no reason for me to be cataloguing clues about Detective Morrow’s marital status.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I got the impression the partners were disagreeing. Maybe it was the way Hansen kept shaking his head and scowling before finally stalking off.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow returned. “Detective Hansen is retrieving the clothes from Evidence. He doubts the trip will be worth it.” He slipped the file of photos back into his desk. “I think we should adjourn to an interview room. The clothes may be more upsetting to you than the photographs would have been.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My new surroundings made the stockroom at Tremayne’s look like a suite at the Beverly Wilshire. A dim overhead bulb spilled weak light over two chairs and a table that had recently hosted a mumblety-peg tournament. Hansen skulked in with a cardboard box. Morrow opened it while Hansen stood sentry in the corner. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“One pair of sandals.” Morrow deposited the shoes on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Silver kid high-heeled sandals with rhinestone buckles,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow scarcely faltered. “One white evening gown.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“White silk, with tulle overlay trimmed in fur.” I glimpsed a dark stain on the dress and averted my gaze, studying the rest of the garment. It was gorgeous, intricately designed. I could envision Ruby wearing it with startling ease. She would have looked like a million bucks that night. She would have looked like a movie star.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your expert opinion, Miss Frost?” Morrow asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s a stunner, all right. Certainly not cheap. Is there a label in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It was cut off. Do you recognize the dress?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s the queer part. I do and I don’t. I feel like I’ve seen it, but not on Ruby.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe on a hanger at the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Tremayne’s doesn’t carry anything like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How can you be sure?” Hansen addressed the table, not me. “You don’t work in Dresses. We found you in … the other department.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His spasm of manners was slightly endearing. “I know our stock. I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“All of it?” Morrow looked dubious. “And where else would you have seen it? You spending your evenings at the Trocadero?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He made a valid point, but I couldn’t shake the certainty that the ivory gown was familiar. The explanation flickered maddeningly at the edge of my thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow placed his hands on the cardboard box like a teacher at a lectern. “Tell me again, when did you start at Tremayne’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Last Christmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Gift-wrapping,” Hansen said, finding the notion amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And that led to your current position? In … the other department?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes.” We were no longer discussing the clothes. My stomach soured. This wasn’t going the way I’d hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“At least the job allowed you to find your own place. You live alone, is that right? Dangerous out there for a girl on her own.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I gestured at the bloodstain on Ruby’s gown without looking at it. “It would appear so.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Getting back to this dress from Tremayne’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I never said that. This dress is not—I don’t think it’s from Tremayne’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Morrow raised a calming hand. “For the sake of argument, let’s assume it is. And Ruby was in her usual dire financial straits. If she wanted this dress, how could she get it from the store?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Steal it,” Hansen fairly spat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Wouldn’t be easy,” Morrow said. “Not with all those salesladies watching. Wouldn’t you agree, Miss Frost?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I may have blinked in response. I hadn’t been whipped around so fast since riding the Thunderbolt at Coney Island.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She’d need help,” Morrow continued. “Someone allowed to handle the merchandise.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“A booster in sheep’s clothing,” Hansen said. “Taking home a paycheck and whatever catches her eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hold on.” My voice was back, bringing my indignation with it. “Are you accusing me of … of stealing clothes? For Ruby? Why would I do that? We weren’t friends anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Big falling out.” Hansen, damn him, was still directing his comments at the scarred tabletop. “Hadn’t spoken in six months.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Unless it wasn’t quite that long.” From his jacket pocket, Morrow removed an envelope. From that envelope, he extracted a scrap of newspaper. Even before he laid it on the table I spotted the curlicued “T” of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tremayne’s")]), _vm._v(", the elegantly elongated “Y.” “We found this in Ruby’s dresser. Do you see why it would strike us as interesting?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The advertisement, from eight weeks earlier, trumpeted the store’s new fall gowns in the Parisian style. Directly beneath the date was “Lillian, 2nd floor” in Ruby’s schoolgirl script. I could picture the pink nib of her tongue protruding as she concentrated on her penmanship.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The detectives’ visit to the store made perfect sense now, their willingness to have me inspect Ruby’s last possessions even more so. They’d known I was lying.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Look ’em in the eye, mermaid.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I did. “We had lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pointed at the advertisement. “Shortly after that ran.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Why not tell us that before?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Because I like my job. I want to keep it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Miss Frost, I don’t care about your job. I want to know about Ruby.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But now you won’t believe me.” I scanned his face for a sign I was mistaken and came up empty.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll decide when I hear what you have to say.” He crossed his arms. “Tell me about this lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Ruby had gotten me into this mess. To get out of it, I did the one thing she’d been incapable of doing. I came clean.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 84
// module chunks = 0